module.exports = __webpack_public_path__ + "static/media/images-1.f63b9f37.png";